import { render, staticRenderFns } from "./otp-modal.vue?vue&type=template&id=9ce56c60&scoped=true&"
import script from "./otp-modal.vue?vue&type=script&lang=js&"
export * from "./otp-modal.vue?vue&type=script&lang=js&"
import style0 from "./otp-modal.vue?vue&type=style&index=0&id=9ce56c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce56c60",
  null
  
)

export default component.exports